<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <v-overlay :value="isLoading">
        <v-progress-circular
            indeterminate
            size="32"
        />
      </v-overlay>
      <v-container flex-fill fluid class="pt-0" v-if="!isLoading">
        <div class="no-data" v-if="noticeList.length === 0">
          <div class="no-data-text">공지사항이 없습니다.</div>
        </div>
        <template v-else>
          <v-expansion-panels accordion flat>
            <v-expansion-panel v-for="(item, i) in noticeList" :key="i">
              <v-expansion-panel-header @click="noticeClick(item.tgNo)">
                <div v-if="item.impt == 'Y'">
                    <span class="v-expansion-panel-header-Y">
                      {{ item.title }}<br/><span class="fs-sm text--secondary">{{ item.regDt | date }}</span>
                    </span>
                </div>
                <div v-if="item.impt == 'N'">
                  {{ item.title }}<br/><span class="fs-sm text--secondary">{{ item.regDt | date }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-html="item.content"></div>
                <div v-if="item.imgAtchNo !== ''" class="mt-5">
                  <v-img :src="$downUrl(item.imgAtchFileName)" contain/>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-container>
    </v-layout>
  </v-main>
</template>
<script>
import store from "@/store";
import moment from "moment";
moment.locale("ko");

export default {
  components: {},
  data: () => ({
    isLoading: false,
    noticeList: []
  }),
  filters: {
    date: function (value) {
      const reg = moment(value).format('YYYY.MM.DD')
      return reg
    },
  },
  created() {
    this.getNoticeList();
  },
  methods: {
    async getNoticeList() {
      this.isLoading = true
      await store.dispatch('getNoticeList')
        .then(res => {
          if (res.success) {
            this.noticeList = res.data;
          } else {
            this.noticeList = [];
          }

        }).catch(error => {
          console.log(error);
          this.noticeList = [];
        }).finally(() => {
            setTimeout(() => {
              this.isLoading = false
            }, 500)
        });
    },
    async updateSearchCount(tgNo) {
      await store.dispatch('updateSearchCount', this.$_payload({'tgNo': tgNo}))
        .then(res => {
          if (res.success) {
            //
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
        });
    },
    noticeClick(tgNo){
      this.updateSearchCount(tgNo);
    }
  }
}
</script>
<style lang="scss" scoped>
.v-expansion-panels::v-deep {
  .v-expansion-panel {
    border-bottom: 1px solid #E6E8EA;
  }

  .v-expansion-panel-header {
    padding-left: 0;
    padding-right: 0;
    font-size: 14px;
    line-height: 22px;
    color: #000;
  }

  .v-expansion-panel-content {
    .v-expansion-panel-content__wrap {
      padding: 0 0 40px;
    }
  }

  .v-expansion-panel-header__icon {
    .mdi-chevron-down::before {
      width: 24px;
      height: 24px;
      content: '';
      background: url('~@/assets/images/ic_arrow_right3.svg') right 7px center no-repeat;
      transform: rotate(90deg);
    }
  }

  .v-expansion-panel-header-Y {
    font-size: 14px;
    line-height: 22px;
    color: #000;
    background: linear-gradient(0deg, #ffffff 100%, transparent 50%);
  }
}
</style>
